import { format as date_format, parse as date_parse } from 'date-fns';
import sanitizeHtml from 'sanitize-html';
import _isFinite from 'lodash/isFinite';

const notstringable = ["object", "function", "symbol"];

export function filterColor (val){
    if(val.indexOf("#") !== 0) val = "#" + val;
    return val.match(/^#([0-9a-f]{3}){1,2}$/i) && val.toUpperCase();
}

export function filterDate (val, f) {
    if (!val || (!val.length && val < 1)) { return '' }
    if (typeof val === 'string' && val.match(/^\s*\d{1,2}:\d{1,2}(:\d{1,2}){0,2}\s*$/)) val = date_format(new Date(), 'YYYY-MM-DD ') + val
    f = f || 'YYYY-MM-DD HH:mm:ss'
    val = date_format(date_parse(val), f)

    // if this is a number, we want to return it as an integer.  lodash may be better here?
    let n = parseInt(val, 10)
    if (val == n) val = n; // eslint-disable-line eqeqeq
    return val
}

/**
 * see https://github.com/apostrophecms/sanitize-html
 * @param {*} val
 * @param {*} rule
 */
export function filterHTML (val, rule) {
    if( !val || notstringable.indexOf(typeof val) > -1 ) return "";

    const config = {
        allowedTags: [
            "a",
            "b",
            "blockquote",
            "br",
            "caption",
            "center",
            "code",
            "div",
            "em",
            "head",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "i",
            "img",
            "li",
            "nl",
            "ol",
            "p",
            "pre",
            "strike",
            "strong",
            "style",
            "table",
            "tbody",
            "td",
            "th",
            "thead",
            "tr",
            "u",
            "ul"
        ],
        disallowedTagsMode: 'discard',
        allowedAttributes: {
            // @TODO at the moment we're going to be stripping lots of stuff that is currently in status report headers with this.
            a: ['href', 'name', 'target'],
            img: ['src'],
            "*": [ 'href', 'align', 'alt', 'center', 'bgcolor', 'id', 'name', 'style', 'class']
        },
        // Lots of these won't come up by default because we don't allow them
        selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
        // URL schemes we permit
        allowedSchemes: ['http', 'https', 'mailto'],
        allowedSchemesByTag: {},
        allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
        allowProtocolRelative: true
        // @TODO add allowedStyles https://github.com/apostrophecms/sanitize-html#allowed-css-styles
    };

    if(rule === "strip") rule = { allowedTags: [], allowedAttributes: {}};
    rule = (rule && typeof rule === "object") ? Object.assign({}, config, rule) : config;

    return sanitizeHtml(val, rule);



    // console.log('filterHTML', rule)
    // let doc = new Option();
    // doc.innerHTML = val;
    // for (let el of doc.getElementsByTagName('script')) {
    //     doc.removeChild(el);
    // }
    // console.log('parent element', doc.children);
    // for (let child of doc.children) {
    //     console.log('filtering', child);
    //     for (let attrName of child.getAttributeNames()) {
    //         console.log('filtering attributes', child, attrName);
    //         if (rule === "all" || attrName.match(/^on/)) child.removeAttribute(attrName);
    //     }
    // }
    // return doc.innerHTML;
}


export function filterId (val) {
    if( !val || notstringable.indexOf(typeof val) > -1 ) return "";
    return val.toString().replace(/[^\w._-]/g,'');
}

export function formatBoolean (val) {
  return (val) ? "True" : "False";
}

export function formatCapitalizeFirst (val) {
    if( !val || notstringable.indexOf(typeof val) > -1 ) return "";
    return val.toString().charAt(0).toUpperCase() + val.slice(1);
}


export function formatDay (val, format) {
    return date_format(date_parse(val), format || 'D MMM');
}

export function isNumber (val) {
    return _isFinite(val)
}